
/**
 * 评估师信息维护
 */
import React, { Component } from 'react';
import { Col, Modal, Form, Input } from 'antd';

import http from '../../../axios/http';
import messager from '../../ui/messager';
import validator from '../../../util/validator';
import DictSelect from '../../ui/DictSelect';
import Image from '../../ui/Image';
import Scanner from '../../ui/Scanner';

const fields = [{
    "text": "证件号",
    "field": "creditNo",
    rules: [
        { required: true, message: '证件号不能为空!' },
        validator.creditNo
    ]
}, {
    "text": "姓名",
    "field": "name",
    rules: [
        { required: true, message: '姓名不能为空!' },
        { max: 32, message: '姓名不能超过32个字符！' },
    ]
}, {
    "text": "电话号码",
    "field": "tel",
    rules: [
        { required: true, message: '电话号码不能为空!' },
        validator.tel
    ],
}, {
    "text": "评估师等级",
    "field": "grade",
    "select": true,
    "category": "ASSESSOR_GRADE",
    rules: [
        { required: true, message: '评估师等级不能为空!' },
    ],
}];

const imageFields = [
    {
        text: '签名图片',
        field: 'signatureUrl'
    }, {
        text: '职业资格证书图片',
        field: 'certificateUrl'
    }
]


class ValuationAssessorEditForm extends Component {

    state = {
        visible: false,
        imageField: "",
        "signatureUrl": "",
        "signatureThumb": "",
        "certificateUrl": "",
        "certificateThumb": ""
    }

    componentWillReceiveProps(newProps) {
        if (!this.props.visible) {
            let signatureThumb = newProps.editData.signatureThumb;
            if (signatureThumb != null && signatureThumb !== "") {
                signatureThumb = "data:image/jpeg;base64," + signatureThumb;
            }
            console.log(this.props.editData.signatureUrl)
            let certificateThumb = newProps.editData.certificateThumb;
            if (certificateThumb != null && certificateThumb !== "") {
                certificateThumb = "data:image/jpeg;base64," + certificateThumb;
            }
            this.setState({
                "signatureUrl": newProps.editData.signatureUrl,
                "signatureThumb": signatureThumb,
                "certificateUrl": newProps.editData.certificateUrl,
                "certificateThumb": certificateThumb
            })
        }
    }


    save = () => {
        const form = this.props.form;
        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            let id = this.props.editData.id
            if (id !== undefined && id != null) {
                values["id"] = id;
            }
            if (this.state.certificateUrl !== "") {
                values["certificateUrl"] = this.state.certificateUrl;
            }
            if (this.state.signatureUrl !== "") {
                values["signatureUrl"] = this.state.signatureUrl;
            }
            http.post({
                url: '/valuationAssessor/save',
                data: values,
                success: (res) => {
                    this.props.successCallback(this.props.queryData);
                    this.props.onCancel();
                    messager.notify("保存成功！");
                }
            });
        });
    };


    createDom = (data) => {
        const { form, editData } = this.props;
        const { getFieldDecorator } = form;
        let dom = [];
        for (let i = 0; i < data.length; i++) {
            let item = data[i];
            let itemDom = (
                <Form.Item key={i} label={item.text + "："}>
                    {
                        getFieldDecorator(item.field, {
                            rules: item.rules,
                            initialValue: editData[item.field],
                        })(
                            item.select ? <DictSelect category={item.category} />
                                : item.textarea ? <Input.TextArea />
                                    : <Input />
                        )
                    }
                </Form.Item>
            );
            dom.push(itemDom);
        }
        return dom;
    };

    createImageDom = (item, field) => {
        let url;
        let file;
        if (field === "signatureUrl") {
            url = this.state.signatureUrl;
            file = this.state.signatureThumb;
        }
        if (field === "certificateUrl") {
            url = this.state.certificateUrl;
            file = this.state.certificateThumb;
        }
        return (
            <Form.Item key={field} label={item.text + "："}>
                <Col span={4} key={field} style={{ height: '112px' }}>
                    <Image
                        openScanner={this.showModal.bind(this, field)}
                        onChange={this.handleUploadImage.bind(this, field)}
                        onRemove={this.handleRemoveImage.bind(this, field)}
                        file={file}
                        text={item.text}
                        url={url}
                    />
                </Col>
            </Form.Item>);
    }

    showModal = (field) => {
        this.setState({ visible: true, imageField: field });
        this.state.initScanner();
    };

    handleUploadImage = (field, { base64 }) => {
        if (field === "signatureUrl") {
            this.setState({ signatureUrl: base64, signatureThumb: base64 });
        }
        if (field === "certificateUrl") {
            this.setState({ certificateUrl: base64, certificateThumb: base64 });
        }
    }

    handleRemoveImage = (field, index) => {
        if (field === "signatureUrl") {
            this.setState({ signatureUrl: "", signatureThumb: "" });
        }
        if (field === "certificateUrl") {
            this.setState({ certificateUrl: "", certificateThumb: "" });
        }
    }

    hiddenModal = () => {
        this.setState({ visible: false });
    };

    handleScan = (base64) => {
        if (base64 != null && base64 !== "") {
            base64 = "data:image/jpeg;base64," + base64.replace(/\r\n/g, "");
            if (this.state.imageField === "signatureUrl") {
                this.setState({ "signatureUrl": base64, "signatureThumb": base64 });
            } else if (this.state.imageField === "certificateUrl") {
                this.setState({ "certificateUrl": base64, "certificateThumb": base64 });
            }
        }
    }

    render() {
        const { visible, onCancel } = this.props;
        const {signatureThumb, certificateThumb} = this.state;
        return (
            <Modal
                width={500}
                visible={visible}
                title="评估师信息编辑"
                okText="保存"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.save}
                afterClose={() => { this.props.form.resetFields() }}
            >
                <Form layout="vertical" labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
                    {this.createDom(fields)}
                    {this.createImageDom(imageFields[0], "signatureUrl", signatureThumb)}
                    {this.createImageDom(imageFields[1], "certificateUrl", certificateThumb)}
                </Form>
                <Scanner
                    visible={this.state.visible}
                    onCancel={this.hiddenModal.bind(this)}
                    initScanner={(func) => { this.setState({ initScanner: func }) }}
                    onScan={this.handleScan}
                />
            </Modal>
        );
    }
}

const ValuationAssessorEdit = Form.create()(ValuationAssessorEditForm);

export default ValuationAssessorEdit;